
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useAvatarBundleItem } from '@/modules/avatar/bundle/model/item';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.BUNDLE.ITEM,
    components: { AppTable, AppCard },
    setup() {
        const { list, total, fetchList, bundle, actions } = useAvatarBundleItem();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Boolean, label: 'Is published', key: 'isPublished' },
                { type: TableColumnType.Boolean, label: 'Is new', key: 'isNew' },
                { type: TableColumnType.Boolean, label: 'Is default', key: 'isDefault' },
                { type: TableColumnType.Text, label: 'Total sale', key: 'totalSale' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_AVATAR.ITEM.EDIT, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-image',
                        theme: 'info',
                        tooltip: 'View images',
                        to: { name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX, params: { itemId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-unlink',
                        theme: 'warning',
                        tooltip: 'Unlink',
                        onclick: () => actions.unlink(bundle.id, row.id)
                    }),
                    canShow: (row: any) => row.canUnlink
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList };
    }
});
